import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { PipesModule } from "src/pipes/pipes.module";
import { FormDatePickerWHeaderComponent } from "./form-date-picker-w-header/form-date-picker-w-header.component";
import { FormDatePickerComponent } from "./form-date-picker/form-date-picker.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ListSelectableModule } from "../list-selectable/list-selectable.module";
import { FormLoginComponent } from "./form-login/form-login.component";
import { FormRequestChangePwdComponent } from "./form-request-change-pwd/form-request-change-pwd.component";
import { FormCreateAccountComponent } from "./form-create-account/form-create-account.component";
import { FormResetPasswordComponent } from "./form-reset-password/form-reset-password.component";
import { FormEditBuildingComponent } from "./form-edit-building/form-edit-building.component";
import { FormEditEnvironmentComponent } from "./form-edit-environment/form-edit-environment.component";
import { FormUserProfileComponent } from "./form-user-profile/form-user-profile.component";
import { FormBillsComponent } from "./form-bills/form-bills.component";
import { FormUserChangePasswordComponent } from "./form-user-change-password/form-user-change-password.component";
import { FormQuoteComponent } from "./form-quote/form-quote.component";
import { SelectFieldComponent } from "src/components/general components/select-field/select-field.component";
import { PasswordCriteriaComponent } from "src/components/general components/password-criteria/password-criteria.component";
import { FormResidentsComponent } from "./form-residents/form-residents.component";
@NgModule({
  declarations: [
    FormDatePickerComponent,
    FormDatePickerWHeaderComponent,
    FormLoginComponent,
    FormRequestChangePwdComponent,
    FormCreateAccountComponent,
    FormResetPasswordComponent,
    FormEditBuildingComponent,
    FormEditEnvironmentComponent,
    FormUserProfileComponent,
    FormUserChangePasswordComponent,
    FormBillsComponent,
    FormQuoteComponent,
    FormResidentsComponent,
  ],
  imports: [
    SelectFieldComponent,
    PasswordCriteriaComponent,
    CommonModule,
    FormsModule,
    IonicComponentsModule,
    ReactiveFormsModule,
    TranslatePipe, TranslateDirective,
    PipesModule,
    MatFormFieldModule,
    MatInputModule,
    ListSelectableModule,
  ],
  exports: [
    FormDatePickerComponent,
    FormDatePickerWHeaderComponent,
    FormLoginComponent,
    FormCreateAccountComponent,
    FormRequestChangePwdComponent,
    FormResetPasswordComponent,
    FormEditBuildingComponent,
    FormEditEnvironmentComponent,
    FormUserProfileComponent,
    FormUserChangePasswordComponent,
    FormBillsComponent,
    FormQuoteComponent,
    FormResidentsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormComponentModule {}
